<template>
    <modal :name="modalID"  :draggable="true" :clickToClose="false" width="360" height="100" 
    @opened="openedHandler" @closed="closedHandler" @keyup.native.esc.exact.capture="hide">
        <div class="term-search-body">
            <div class="term-search-line">

                <el-input :id="modalID + '-input'" size="mini" :placeholder="(isRegex ? 'Regex' : 'Text') + ' for searching'" prefix-icon="el-icon-search" 
                v-model="pattern" type="search" class="term-search-input" @keyup.native.enter.exact="search('next')" @keyup.native.shift.enter.exact="search('prev')"/>

                <div class="el-icon-arrow-down term-search-btn" @click="search('next')" />
                <div class="el-icon-arrow-up term-search-btn" @click="search('prev')" />
                <div class="el-icon-close term-search-btn" @click="hide" />
            </div>
            
            <div class="term-search-line">
                <el-checkbox v-model="matchCase">区分大小写</el-checkbox>
                <el-checkbox v-model="isRegex">正则表达式</el-checkbox>
                <el-checkbox v-model="isWholeWord">全词匹配</el-checkbox>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "terminalSearch",
    props: ["modalID"],
    data() {
        return {
            pattern: "",
            matchCase: false,
            isRegex: false,
            isWholeWord: false,
        }
    },
    watch: {
        pattern: function() { this.search('next') },
        matchCase: function() { this.search('next') },
        isRegex: function() { this.search('next') },
        isWholeWord: function() { this.search('next') },
    },
    methods: {
        show() {
            this.$modal.show(this.modalID)
        },
        hide() {
            this.$modal.hide(this.modalID)
        },
        openedHandler() {
            this.utils.dom.domFocusById(this.modalID + '-input')
        },
        closedHandler() {
            this.$emit('closed')
        },
        search(direction) {
            this.$emit('search', {
                direction: direction,   // string: "next"/"prev"
                pattern: this.pattern,  // string: search pattern
                matchCase: this.matchCase,
                isRegex: this.isRegex,
                isWholeWord: this.isWholeWord
            })
        },
    },
}
</script>

<style>
.tab-terms-ctn>.vm--container {
    pointer-events: none;
}
.tab-terms-ctn>.vm--container>.vm--overlay {
    display: none;
}
.tab-terms-ctn>.vm--container>.vm--modal {
    pointer-events: all;
    color: #fff;
    background-color: #3c3c3c;
}
</style>

<style scoped>
.term-search-body {
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.term-search-btn {
  color: #c6c6c6;
  padding: 8px;
}
.term-search-btn:hover {
  color: white;
  background: #333;
}
.term-search-btn:active {
  color: white;
  background: #222;
}


.term-search-line {
    margin-top: 1em;
    display: flex;
}

.term-search-input {
    width: 232px;
    margin-right: 0.5em;;
}
</style>